module.exports = __webpack_public_path__ + "img/coworkers.6a92017e.svg";